<template>
  <fragment>
    <b-table
      responsive
      show-empty
      empty-text="No projects available"
      :busy="loading"
      sort-icon-left
      :fields="fields"
      :items="projects"
      @row-clicked="toggleTableRow"
      striped
      ref="table"
    >
      <template v-slot:table-busy>
        <div class="text-center">
          <b-spinner
            variant="primary"
            class="align-middle"
            :label="$t('messages.loading')"
          ></b-spinner>
        </div>
      </template>

      <template v-slot:cell(status)="data">
        <StatusIcon
          :status="data.item.provisionLeadStatus"
          :daysToExpired="data.item.daysToExpired"
        />
      </template>

      <template v-slot:cell(quotedTotalAmount)="data">
        {{ data.item.quotedTotalAmount | currency(user.currency) }}
      </template>

      <template v-slot:cell(reportedTotalCost)="data">
        {{ data.item.reportedTotalCost | currency(user.currency) }}
      </template>

      <template v-slot:cell(action)="data">
        <b-button @click="data.toggleDetails">{{
          data.detailsShowing ? $t('buttons.close') : $t('buttons.report_quote')
        }}</b-button>
      </template>

      <template v-slot:row-details="data">
        <ProjectDataForm
          :user="user"
          :projectId="data.item.projectId"
          :externalWinner="data.item.externalWinner"
          @submit="refreshTable"
        />
      </template>
    </b-table>
  </fragment>
</template>
<script>
import api from '../../api/api';
import StatusIcon from '@/components/StatusIcon.vue';
import ProjectDataForm from './ProjectDataForm.vue';

export default {
  components: {
    StatusIcon,
    ProjectDataForm,
  },
  data() {
    return {
      loading: false,
      projects: [],
    };
  },
  mounted() {
    this.getReportedWinners();
  },
  computed: {
    fields() {
      return [
        { key: 'projectId', label: 'Project id', sortable: true },
        { key: 'title', label: this.$t('table.header.title'), sortable: true },
        {
          key: 'location',
          label: this.$t('table.header.location'),
          sortable: true,
        },
        {
          key: 'buyerName',
          label: this.$t('table.header.buyer'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('table.header.status'),
          sortable: true,
        },
        {
          key: 'quotedTotalAmount',
          label: this.$t('user.payment_history.amount'),
          sortable: true,
        },
        {
          key: 'reportedTotalCost',
          label: 'Reported total',
          sortable: true,
        },
        {
          key: 'action',
          label: '',
          sortable: false,
        },
      ];
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    toggleTableRow(item) {
      this.$set(item, '_showDetails', !item._showDetails);
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    getReportedWinners() {
      this.loading = true;

      api
        .getReportedWinners()
        .then((res) => (this.projects = res.data))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
